import { render } from "./VUEMessaggio.vue?vue&type=template&id=c7a402b8"
import script from "./VUEMessaggio.vue?vue&type=script&lang=js"
export * from "./VUEMessaggio.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__